import {cleanContent} from '../../../utils/cleanHTMLContent';

export const mapHelpData = helpData => {
    if (!helpData) return null;

    const link = helpData.Links;
    const data = helpData.Text;
    const content = cleanContent(data, true);

    const linkData = Object.entries(link)
        .map(([key, value]) => ({
            from: content.indexOf(key),
            len: key.length,
            title: value,
            linkData: {
                eName: key.replace(/[{}]/g, '').split('.')[0]
            }
        }))
        .sort((a, b) => (a.from < b.from ? -1 : 1));

    return {content, linkData};
};
